import axios from 'axios';
import axiosHelper from 'utils/axiosHelper';
import { addNotification, NotificationImportance } from '../common/commonActions';
import { ParametreCodes } from 'constants.js';

/**
 * Liste des actions
 */
export const Actions = {
    FETCH_ADMINISTRATION_GROUPES_REQUEST: 'FETCH_ADMINISTRATION_GROUPES_REQUEST',
    FETCH_ADMINISTRATION_GROUPES_SUCCESS: 'FETCH_ADMINISTRATION_GROUPES_SUCCESS',
    FETCH_ADMINISTRATION_GROUPES_FAILURE: 'FETCH_ADMINISTRATION_GROUPES_FAILURE',

    FETCH_ADMINISTRATION_GROUPE_REQUEST: 'FETCH_ADMINISTRATION_GROUPE_REQUEST',
    FETCH_ADMINISTRATION_GROUPE_SUCCESS: 'FETCH_ADMINISTRATION_GROUPE_SUCCESS',
    FETCH_ADMINISTRATION_GROUPE_FAILURE: 'FETCH_ADMINISTRATION_GROUPE_FAILURE',

    PATCH_GROUPE_REQUEST: 'PATCH_GROUPE_REQUEST',
    PATCH_GROUPE_SUCCESS: 'PATCH_GROUPE_SUCCESS',
    PATCH_GROUPE_FAILURE: 'PATCH_GROUPE_FAILURE',

    FETCH_ADMINISTRATION_ACTIONS_NON_GENERIQUES_REQUEST: 'FETCH_ADMINISTRATION_ACTIONS_NON_GENERIQUES_REQUEST',
    FETCH_ADMINISTRATION_ACTIONS_NON_GENERIQUES_SUCCESS: 'FETCH_ADMINISTRATION_ACTIONS_NON_GENERIQUES_SUCCESS',
    FETCH_ADMINISTRATION_ACTIONS_NON_GENERIQUES_FAILURE: 'FETCH_ADMINISTRATION_ACTIONS_NON_GENERIQUES_FAILURE',

    FETCH_ADMINISTRATION_GROUPES_SECURITE_REQUEST: 'FETCH_ADMINISTRATION_GROUPES_SECURITE_REQUEST',
    FETCH_ADMINISTRATION_GROUPES_SECURITE_SUCCESS: 'FETCH_ADMINISTRATION_GROUPES_SECURITE_SUCCESS',
    FETCH_ADMINISTRATION_GROUPES_SECURITE_FAILURE: 'FETCH_ADMINISTRATION_GROUPES_SECURITE_FAILURE',

    FETCH_ADMINISTRATION_TRANSPORTEURS_REQUEST: 'FETCH_ADMINISTRATION_TRANSPORTEURS_REQUEST',
    FETCH_ADMINISTRATION_TRANSPORTEURS_SUCCESS: 'FETCH_ADMINISTRATION_TRANSPORTEURS_SUCCESS',
    FETCH_ADMINISTRATION_TRANSPORTEURS_FAILURE: 'FETCH_ADMINISTRATION_TRANSPORTEURS_FAILURE',

    PATCH_TRANSPORTEUR_REQUEST: 'PATCH_TRANSPORTEUR_REQUEST',
    PATCH_TRANSPORTEUR_SUCCESS: 'PATCH_TRANSPORTEUR_SUCCESS',
    PATCH_TRANSPORTEUR_FAILURE: 'PATCH_TRANSPORTEUR_FAILURE',

    POST_TRANSPORTEUR_REQUEST: 'POST_TRANSPORTEUR_REQUEST',
    POST_TRANSPORTEUR_SUCCESS: 'POST_TRANSPORTEUR_SUCCESS',
    POST_TRANSPORTEUR_FAILURE: 'POST_TRANSPORTEUR_FAILURE',

    DELETE_TRANSPORTEUR_REQUEST: 'DELETE_TRANSPORTEUR_REQUEST',
    DELETE_TRANSPORTEUR_SUCCESS: 'DELETE_TRANSPORTEUR_SUCCESS',
    DELETE_TRANSPORTEUR_FAILURE: 'DELETE_TRANSPORTEUR_FAILURE',

    PATCH_TRANSPORTEUR_COMPTE_REQUEST: 'PATCH_TRANSPORTEUR_COMPTE_REQUEST',
    PATCH_TRANSPORTEUR_COMPTE_SUCCESS: 'PATCH_TRANSPORTEUR_COMPTE_SUCCESS',
    PATCH_TRANSPORTEUR_COMPTE_FAILURE: 'PATCH_TRANSPORTEUR_COMPTE_FAILURE',

    POST_TRANSPORTEUR_COMPTE_REQUEST: 'POST_TRANSPORTEUR_COMPTE_REQUEST',
    POST_TRANSPORTEUR_COMPTE_SUCCESS: 'POST_TRANSPORTEUR_COMPTE_SUCCESS',
    POST_TRANSPORTEUR_COMPTE_FAILURE: 'POST_TRANSPORTEUR_FAILURE',

    DELETE_TRANSPORTEUR_COMPTE_REQUEST: 'DELETE_TRANSPORTEUR_COMPTE_REQUEST',
    DELETE_TRANSPORTEUR_COMPTE_SUCCESS: 'DELETE_TRANSPORTEUR_COMPTE_SUCCESS',
    DELETE_TRANSPORTEUR_COMPTE_FAILURE: 'DELETE_TRANSPORTEUR_COMPTE_FAILURE',

    SET_DEFAUT_TRANSPORTEUR_COMPTE_REQUEST: 'SET_DEFAUT_TRANSPORTEUR_COMPTE_REQUEST',
    SET_DEFAUT_TRANSPORTEUR_COMPTE_SUCCESS: 'SET_DEFAUT_TRANSPORTEUR_COMPTE_SUCCESS',
    SET_DEFAUT_TRANSPORTEUR_COMPTE_FAILURE: 'SET_DEFAUT_TRANSPORTEUR_COMPTE_FAILURE',

    FETCH_ADMINISTRATION_MOTIFS_RESOLUTION_REQUEST: 'FETCH_ADMINISTRATION_MOTIFS_RESOLUTION_REQUEST',
    FETCH_ADMINISTRATION_MOTIFS_RESOLUTION_SUCCESS: 'FETCH_ADMINISTRATION_MOTIFS_RESOLUTION_SUCCESS',
    FETCH_ADMINISTRATION_MOTIFS_RESOLUTION_FAILURE: 'FETCH_ADMINISTRATION_MOTIFS_RESOLUTION_FAILURE',

    PATCH_MOTIF_RESOLUTION_REQUEST: 'PATCH_MOTIF_RESOLUTION_REQUEST',
    PATCH_MOTIF_RESOLUTION_SUCCESS: 'PATCH_MOTIF_RESOLUTION_SUCCESS',
    PATCH_MOTIF_RESOLUTION_FAILURE: 'PATCH_MOTIF_RESOLUTION_FAILURE',

    POST_MOTIF_RESOLUTION_REQUEST: 'POST_MOTIF_RESOLUTION_REQUEST',
    POST_MOTIF_RESOLUTION_SUCCESS: 'POST_MOTIF_RESOLUTION_SUCCESS',
    POST_MOTIF_RESOLUTION_FAILURE: 'POST_MOTIF_RESOLUTION_FAILURE',

    DELETE_MOTIF_RESOLUTION_REQUEST: 'DELETE_MOTIF_RESOLUTION_REQUEST',
    DELETE_MOTIF_RESOLUTION_SUCCESS: 'DELETE_MOTIF_RESOLUTION_SUCCESS',
    DELETE_MOTIF_RESOLUTION_FAILURE: 'DELETE_MOTIF_RESOLUTION_FAILURE',

    FETCH_ADMINISTRATION_CAUSES_PRINCIPALES_REQUEST: 'FETCH_ADMINISTRATION_CAUSES_PRINCIPALES_REQUEST',
    FETCH_ADMINISTRATION_CAUSES_PRINCIPALES_SUCCESS: 'FETCH_ADMINISTRATION_CAUSES_PRINCIPALES_SUCCESS',
    FETCH_ADMINISTRATION_CAUSES_PRINCIPALES_FAILURE: 'FETCH_ADMINISTRATION_CAUSES_PRINCIPALES_FAILURE',

    PATCH_CAUSE_PRINCIPALE_REQUEST: 'PATCH_CAUSE_PRINCIPALE_REQUEST',
    PATCH_CAUSE_PRINCIPALE_SUCCESS: 'PATCH_CAUSE_PRINCIPALE_SUCCESS',
    PATCH_CAUSE_PRINCIPALE_FAILURE: 'PATCH_CAUSE_PRINCIPALE_FAILURE',

    POST_CAUSE_PRINCIPALE_REQUEST: 'POST_CAUSE_PRINCIPALE_REQUEST',
    POST_CAUSE_PRINCIPALE_SUCCESS: 'POST_CAUSE_PRINCIPALE_SUCCESS',
    POST_CAUSE_PRINCIPALE_FAILURE: 'POST_CAUSE_PRINCIPALE_FAILURE',

    DELETE_CAUSE_PRINCIPALE_REQUEST: 'DELETE_CAUSE_PRINCIPALE_REQUEST',
    DELETE_CAUSE_PRINCIPALE_SUCCESS: 'DELETE_CAUSE_PRINCIPALE_SUCCESS',
    DELETE_CAUSE_PRINCIPALE_FAILURE: 'DELETE_CAUSE_PRINCIPALE_FAILURE',
    
    FETCH_CLIENTS_PRIORITAIRES_REQUEST: 'FETCH_CLIENTS_PRIORITAIRES_REQUEST',
    FETCH_CLIENTS_PRIORITAIRES_SUCCESS: 'FETCH_CLIENTS_PRIORITAIRES_SUCCESS',
    FETCH_CLIENTS_PRIORITAIRES_FAILURE: 'FETCH_CLIENTS_PRIORITAIRES_FAILURE',

    CLEAR_CLIENTS_PRIORITAIRES: 'CLEAR_CLIENTS_PRIORITAIRES',

    IMPORT_CLIENTS_PRIORITAIRES_REQUEST: 'IMPORT_CLIENTS_PRIORITAIRES_REQUEST',
    IMPORT_CLIENTS_PRIORITAIRES_SUCCESS: 'IMPORT_CLIENTS_PRIORITAIRES_SUCCESS',
    IMPORT_CLIENTS_PRIORITAIRES_FAILURE: 'IMPORT_CLIENTS_PRIORITAIRES_FAILURE',

    PATCH_CLIENT_REQUEST: 'PATCH_CLIENT_REQUEST',
    PATCH_CLIENT_SUCCESS: 'PATCH_CLIENT_SUCCESS',
    PATCH_CLIENT_FAILURE: 'PATCH_CLIENT_FAILURE',

    PATCH_FOURNISSEUR_REQUEST: 'PATCH_FOURNISSEUR_REQUEST',
    PATCH_FOURNISSEUR_SUCCESS: 'PATCH_FOURNISSEUR_SUCCESS',
    PATCH_FOURNISSEUR_FAILURE: 'PATCH_FOURNISSEUR_FAILURE',

    FETCH_ADMINISTRATION_FRAIS_RETOUR_EXCLUS_REQUEST: 'FETCH_ADMINISTRATION_FRAIS_RETOUR_EXCLUS_REQUEST',
    FETCH_ADMINISTRATION_FRAIS_RETOUR_EXCLUS_SUCCESS: 'FETCH_ADMINISTRATION_FRAIS_RETOUR_EXCLUS_SUCCESS',
    FETCH_ADMINISTRATION_FRAIS_RETOUR_EXCLUS_FAILURE: 'FETCH_ADMINISTRATION_TRANSPORTEURS_FAILURE',

    POST_FRAIS_RETOUR_EXCLU_REQUEST: 'POST_FRAIS_RETOUR_EXCLU_REQUEST',
    POST_FRAIS_RETOUR_EXCLU_SUCCESS: 'POST_FRAIS_RETOUR_EXCLU_SUCCESS',
    POST_FRAIS_RETOUR_EXCLU_FAILURE: 'POST_FRAIS_RETOUR_EXCLU_FAILURE',

    DELETE_FRAIS_RETOUR_EXCLU_REQUEST: 'DELETE_FRAIS_RETOUR_EXCLU_REQUEST',
    DELETE_FRAIS_RETOUR_EXCLU_SUCCESS: 'DELETE_FRAIS_RETOUR_EXCLU_SUCCESS',
    DELETE_FRAIS_RETOUR_EXCLU_FAILURE: 'DELETE_FRAIS_RETOUR_EXCLU_FAILURE',



    FETCH_ADMINISTRATION_DECOTE_RETOUR_EXCLUS_REQUEST: 'FETCH_ADMINISTRATION_DECOTE_RETOUR_EXCLUS_REQUEST',
    FETCH_ADMINISTRATION_DECOTE_RETOUR_EXCLUS_SUCCESS: 'FETCH_ADMINISTRATION_DECOTE_RETOUR_EXCLUS_SUCCESS',
    FETCH_ADMINISTRATION_DECOTE_RETOUR_EXCLUS_FAILURE: 'FETCH_ADMINISTRATION_TRANSPORTEURS_FAILURE',

    POST_DECOTE_RETOUR_EXCLU_REQUEST: 'POST_DECOTE_RETOUR_EXCLU_REQUEST',
    POST_DECOTE_RETOUR_EXCLU_SUCCESS: 'POST_DECOTE_RETOUR_EXCLU_SUCCESS',
    POST_DECOTE_RETOUR_EXCLU_FAILURE: 'POST_DECOTE_RETOUR_EXCLU_FAILURE',

    DELETE_DECOTE_RETOUR_EXCLU_REQUEST: 'DELETE_DECOTE_RETOUR_EXCLU_REQUEST',
    DELETE_DECOTE_RETOUR_EXCLU_SUCCESS: 'DELETE_DECOTE_RETOUR_EXCLU_SUCCESS',
    DELETE_DECOTE_RETOUR_EXCLU_FAILURE: 'DELETE_DECOTE_RETOUR_EXCLU_FAILURE',

    FETCH_ADMINISTRATION_RETOUR_EXCLUS_REQUEST: 'FETCH_ADMINISTRATION_RETOUR_EXCLUS_REQUEST',
    FETCH_ADMINISTRATION_RETOUR_EXCLUS_SUCCESS: 'FETCH_ADMINISTRATION_RETOUR_EXCLUS_SUCCESS',
    FETCH_ADMINISTRATION_RETOUR_EXCLUS_FAILURE: 'FETCH_ADMINISTRATION_TRANSPORTEURS_FAILURE',

    POST_RETOUR_EXCLU_REQUEST: 'POST_RETOUR_EXCLU_REQUEST',
    POST_RETOUR_EXCLU_SUCCESS: 'POST_RETOUR_EXCLU_SUCCESS',
    POST_RETOUR_EXCLU_FAILURE: 'POST_RETOUR_EXCLU_FAILURE',

    DELETE_RETOUR_EXCLU_REQUEST: 'DELETE_RETOUR_EXCLU_REQUEST',
    DELETE_RETOUR_EXCLU_SUCCESS: 'DELETE_RETOUR_EXCLU_SUCCESS',
    DELETE_RETOUR_EXCLU_FAILURE: 'DELETE_RETOUR_EXCLU_FAILURE',

    FETCH_ADMINISTRATION_PCT_JOKER_FRAIS_RETOUR_REQUEST: 'FETCH_ADMINISTRATION_PCT_JOKER_FRAIS_RETOUR_REQUEST', // Note, en cas de nouveau paramètre, ne plus passer par redux.
    FETCH_ADMINISTRATION_PCT_JOKER_FRAIS_RETOUR_SUCCESS: 'FETCH_ADMINISTRATION_PCT_JOKER_FRAIS_RETOUR_SUCCESS',
    FETCH_ADMINISTRATION_PCT_JOKER_FRAIS_RETOUR_FAILURE: 'FETCH_ADMINISTRATION_PCT_JOKER_FRAIS_RETOUR_FAILURE',

    PATCH_REPRESENTANT_REQUEST: 'PATCH_REPRESENTANT_REQUEST',
    PATCH_REPRESENTANT_SUCCESS: 'PATCH_REPRESENTANT_SUCCESS',
    PATCH_REPRESENTANT_FAILURE: 'PATCH_REPRESENTANT_FAILURE',
};

/**
 * FETCH_ADMINISTRATION_GROUPES
 * ActionCreator pour la récupération des groupes pour l'administration
 */
const fetchAdministrationGroupesRequest = () => ({ type: Actions.FETCH_ADMINISTRATION_GROUPES_REQUEST });
const fetchAdministrationGroupesSuccess = items => ({ type: Actions.FETCH_ADMINISTRATION_GROUPES_SUCCESS, items });
const fetchAdministrationGroupesFailure = error => ({ type: Actions.FETCH_ADMINISTRATION_GROUPES_FAILURE, error });

export const fetchAdministrationGroupes = () => (dispatch, getState) => {
    if (getState().administration.groupes.isLoading || getState().administration.groupes.isPatching) {
        return;
    }
    return dispatch(_fetchAdministrationGroupes());
};

const _fetchAdministrationGroupes = () => async (dispatch) => {

    dispatch(fetchAdministrationGroupesRequest());

    try {
        let response = await axios.get('api/groupes/administration');
        dispatch(fetchAdministrationGroupesSuccess(response.data));
    } catch (error) {
        console.error('fetchAdministrationGroupes : ', error);
        dispatch(fetchAdministrationGroupesFailure(error));
    }

};



/**
 * FETCH_ADMINISTRATION_GROUPE
 * ActionCreator pour la récupération d'un groupe pour l'administration
 */
const fetchAdministrationGroupeRequest = id => ({ type: Actions.FETCH_ADMINISTRATION_GROUPE_REQUEST, id });
const fetchAdministrationGroupeSuccess = item => ({ type: Actions.FETCH_ADMINISTRATION_GROUPE_SUCCESS, item });
const fetchAdministrationGroupeFailure = error => ({ type: Actions.FETCH_ADMINISTRATION_GROUPE_FAILURE, error });

export const fetchAdministrationGroupe = (id) => (dispatch, getState) => {
    if (getState().administration.groupes.isLoading || getState().administration.groupes.isPatching) {
        return;
    }
    return dispatch(_fetchAdministrationGroupe(id));
};

const _fetchAdministrationGroupe = (id) => async (dispatch) => {

    dispatch(fetchAdministrationGroupeRequest(id));

    try {
        let response = await axios.get(`api/groupes/${id}/administration`);
        dispatch(fetchAdministrationGroupeSuccess(response.data));
    } catch (error) {
        console.error(`fetchAdministrationGroupe : ${id}`, error);
        dispatch(fetchAdministrationGroupeFailure(error));
    }

};


/**
 * PATCH_GROUPE_
 * ActionCreator pour la modification d'un groupe
 */
const patchGroupeRequest = groupe => ({ type: Actions.PATCH_GROUPE_REQUEST, groupe });
const patchGroupeSuccess = groupe => ({ type: Actions.PATCH_GROUPE_SUCCESS, groupe });
const patchGroupeFailure = error => ({ type: Actions.PATCH_GROUPE_FAILURE, error });

export const patchGroupe = (groupe, actionsIds, motifsResolutionIds, causesPrincipalesIds) => (dispatch, getState) => {
    if (getState().administration.groupes.isLoading || getState().administration.groupes.isPatching) {
        return;
    }
    return dispatch(_patchGroupe(groupe, actionsIds, motifsResolutionIds, causesPrincipalesIds));
};

const _patchGroupe = (groupe, actionsIds, motifsResolutionIds, causesPrincipalesIds) => async (dispatch) => {

    dispatch(patchGroupeRequest(groupe));

    let params = {
        libelle: groupe.libelle,
        initiales: groupe.initiales,
        actif: groupe.actif,
        visible: groupe.visible,
        autoriseCreationReclamationLiee: groupe.autoriseCreationReclamationLiee,
        autoriseSAV: groupe.autoriseSAV,
        autoriseMemo: groupe.autoriseMemo,
        notifierPilote: groupe.notifierPilote,
        notifierEmetteurReclamation: groupe.notifierEmetteurReclamation,
        pilotesIds: groupe.pilotes.map(x => x.id),
        actionsIds: actionsIds,
        motifsResolutionIds: motifsResolutionIds,
        causesPrincipalesIds: causesPrincipalesIds,
        groupesSecurite: groupe.groupesSecurite
    };

    try {
        let response = await axios.patch(`api/groupes/${groupe.id}`, params);
        dispatch(patchGroupeSuccess(response.data));
        dispatch(addNotification(`Le groupe ${groupe.code} a bien été modifié.`, NotificationImportance.success));
    } catch (error) {
        console.error('_patchGroupe : ', error);
        dispatch(patchGroupeFailure(error));
        dispatch(addNotification(`Impossible de modifier le groupe ${groupe.code}.`, NotificationImportance.error));
    }
};

/**
 * FETCH_ADMINISTRATION_ACTIONS_NON_GENERIQUES
 * ActionCreator pour la récupération des TypAction pour l'administration
 */
const fetchAdministrationActionsNonGeneriquesRequest = () => ({ type: Actions.FETCH_ADMINISTRATION_ACTIONS_NON_GENERIQUES_REQUEST });
const fetchAdministrationActionsNonGeneriquesSuccess = items => ({ type: Actions.FETCH_ADMINISTRATION_ACTIONS_NON_GENERIQUES_SUCCESS, items });
const fetchAdministrationActionsNonGeneriquesFailure = error => ({ type: Actions.FETCH_ADMINISTRATION_ACTIONS_NON_GENERIQUES_FAILURE, error });

export const fetchAdministrationActionsNonGeneriques = () => (dispatch, getState) => {
    if (getState().administration.actionsNonGeneriques.isLoading) {
        return;
    }
    if (getState().administration.actionsNonGeneriques.items.length > 0) {
        return;
    }
    return dispatch(_fetchAdministrationActionsNonGeneriques());
};

const _fetchAdministrationActionsNonGeneriques = () => async (dispatch) => {

    dispatch(fetchAdministrationActionsNonGeneriquesRequest());

    try {
        let response = await axios.get('api/typesaction/non-generiques');
        dispatch(fetchAdministrationActionsNonGeneriquesSuccess(response.data));
    } catch (error) {
        console.error('fetchAdministrationActionsNonGeneriques : ', error);
        dispatch(fetchAdministrationActionsNonGeneriquesFailure(error));
    }

};

/**
 * FETCH_ADMINISTRATION_GROUPES_SECURITE
 * ActionCreator pour la récupération des groupes sécurité pour l'administration
 */
const fetchAdministrationGroupesSecuriteRequest = () => ({ type: Actions.FETCH_ADMINISTRATION_GROUPES_SECURITE_REQUEST });
const fetchAdministrationGroupesSecuriteSuccess = items => ({ type: Actions.FETCH_ADMINISTRATION_GROUPES_SECURITE_SUCCESS, items });
const fetchAdministrationGroupesSecuriteFailure = error => ({ type: Actions.FETCH_ADMINISTRATION_GROUPES_SECURITE_FAILURE, error });

export const fetchAdministrationGroupesSecurite = () => (dispatch, getState) => {
    if (getState().administration.groupesSecurite.isLoading) {
        return;
    }
    if (getState().administration.groupesSecurite.items.length > 0) {
        return;
    }
    return dispatch(_fetchAdministrationGroupesSecurite());
};

const _fetchAdministrationGroupesSecurite = () => async (dispatch) => {

    dispatch(fetchAdministrationGroupesSecuriteRequest());

    try {
        let response = await axios.get('api/groupes-securite');
        dispatch(fetchAdministrationGroupesSecuriteSuccess(response.data));
    } catch (error) {
        console.error('fetchAdministrationGroupesSecurite : ', error);
        dispatch(fetchAdministrationGroupesSecuriteFailure(error));
    }

};

/**
 * FETCH_ADMINISTRATION_TRANSPORTEURS
 * ActionCreator pour la récupération des transporteurs pour l'administration
 */
const fetchAdministrationTransporteursRequest = () => ({ type: Actions.FETCH_ADMINISTRATION_TRANSPORTEURS_REQUEST });
const fetchAdministrationTransporteursSuccess = items => ({ type: Actions.FETCH_ADMINISTRATION_TRANSPORTEURS_SUCCESS, items });
const fetchAdministrationTransporteursFailure = error => ({ type: Actions.FETCH_ADMINISTRATION_TRANSPORTEURS_FAILURE, error });

export const fetchAdministrationTransporteurs = () => (dispatch, getState) => {
    if (getState().administration.transporteurs.isLoading || getState().administration.transporteurs.isPatching) {
        return;
    }
    if (getState().administration.transporteurs.items.length > 0) {
        return;
    }
    return dispatch(_fetchAdministrationTransporteurs());
};

const _fetchAdministrationTransporteurs = () => async (dispatch) => {

    dispatch(fetchAdministrationTransporteursRequest());

    try {
        let response = await axios.get('api/transporteurs/administration');
        dispatch(fetchAdministrationTransporteursSuccess(response.data));
    } catch (error) {
        console.error('fetchAdministrationTransporteurs : ', error);
        dispatch(fetchAdministrationTransporteursFailure(error));
    }

};

/**
 * PATCH_TRANSPORTEUR_
 * ActionCreator pour la modification d'un transporteur
 */
const patchTransporteurRequest = transporteur => ({ type: Actions.PATCH_TRANSPORTEUR_REQUEST, transporteur });
const patchTransporteurSuccess = transporteur => ({ type: Actions.PATCH_TRANSPORTEUR_SUCCESS, transporteur });
const patchTransporteurFailure = error => ({ type: Actions.PATCH_TRANSPORTEUR_FAILURE, error });

export const patchTransporteur = (transporteur) => (dispatch, getState) => {
    if (getState().administration.transporteurs.isLoading || getState().administration.transporteurs.isPatching) {
        return;
    }
    return dispatch(_patchTransporteur(transporteur));
};

const _patchTransporteur = (transporteur) => async (dispatch) => {

    dispatch(patchTransporteurRequest(transporteur));

    let params = {
        nom: transporteur.nom,
        type: transporteur.type,
        transporteursLogistique: transporteur.transporteursLogistique
    };

    try {
        let response = await axios.patch(`api/transporteurs/${transporteur.id}`, params);
        dispatch(patchTransporteurSuccess(response.data));
        dispatch(addNotification(`Le transporteur ${transporteur.code} a bien été modifié.`, NotificationImportance.success));
    } catch (error) {
        console.error('_patchTransporteur : ', error);
        dispatch(patchTransporteurFailure(error));
        dispatch(addNotification(`Impossible de modifier le transporteur ${transporteur.code}.`, NotificationImportance.error));
    }

};

/**
 * POST_TRANSPORTEUR_
 * ActionCreator pour la création d'un transporteur
 */
const postTransporteurRequest = transporteur => ({ type: Actions.POST_TRANSPORTEUR_REQUEST, transporteur });
const postTransporteurSuccess = transporteur => ({ type: Actions.POST_TRANSPORTEUR_SUCCESS, transporteur });
const postTransporteurFailure = error => ({ type: Actions.POST_TRANSPORTEUR_FAILURE, error });

export const postTransporteur = (transporteur) => (dispatch, getState) => {
    if (getState().administration.transporteurs.isLoading || getState().administration.transporteurs.isPatching) {
        return;
    }
    return dispatch(_postTransporteur(transporteur));
};

const _postTransporteur = (transporteur) => async (dispatch) => {

    dispatch(postTransporteurRequest(transporteur));

    let params = {
        code: transporteur.code,
        nom: transporteur.nom,
        type: transporteur.type,
        codes: transporteur.codes
    };

    try {
        let response = await axios.post(`api/transporteurs/`, params);
        dispatch(postTransporteurSuccess(response.data));
        dispatch(addNotification(`Le transporteur ${transporteur.code} a bien été ajouté.`, NotificationImportance.success));
    } catch (error) {
        console.error('_postTransporteur : ', error);
        dispatch(postTransporteurFailure(error));
        dispatch(addNotification(`Impossible d'ajouter le transporteur ${transporteur.code}.`, NotificationImportance.error));
    }
};

/**
 * DELETE_TRANSPORTEUR_
 * ActionCreator pour la suppression d'un transporteur
 */
const deleteTransporteurRequest = transporteurId => ({ type: Actions.DELETE_TRANSPORTEUR_REQUEST, transporteurId });
const deleteTransporteurSuccess = transporteurId => ({ type: Actions.DELETE_TRANSPORTEUR_SUCCESS, transporteurId });
const deleteTransporteurFailure = error => ({ type: Actions.DELETE_TRANSPORTEUR_FAILURE, error });

export const deleteTransporteur = (transporteurId) => (dispatch, getState) => {
    if (getState().administration.transporteurs.isLoading || getState().administration.transporteurs.isPatching) {
        return;
    }
    return dispatch(_deleteTransporteur(transporteurId));
};

const _deleteTransporteur = (transporteurId) => async (dispatch) => {

    dispatch(deleteTransporteurRequest(transporteurId));
    
    try {
        let response = await axios.delete(`api/transporteurs/${transporteurId}`);
        dispatch(deleteTransporteurSuccess(response.data));
        dispatch(addNotification(`Le transporteur ${transporteurId} a bien été supprimé.`, NotificationImportance.success));
    } catch (error) {
        console.error('_deleteTransporteur : ', error);
        dispatch(deleteTransporteurFailure(error));
        dispatch(addNotification(`Impossible de supprimer le transporteur ${transporteurId}.`, NotificationImportance.error));
    }
};

/**
 * POST_TRANSPORTEUR_COMPTE_
 * ActionCreator pour la création d'un transporteurCompte
 */
const postTransporteurCompteRequest = () => ({ type: Actions.POST_TRANSPORTEUR_COMPTE_REQUEST });
const postTransporteurCompteSuccess = transporteurCompte => ({ type: Actions.POST_TRANSPORTEUR_COMPTE_SUCCESS, transporteurCompte });
const postTransporteurCompteFailure = error => ({ type: Actions.POST_TRANSPORTEUR_COMPTE_FAILURE, error });

export const postTransporteurCompte = ( transporteur, transporteurCompte ) => (dispatch, getState) => {
    if (getState().administration.transporteurs.isLoading || getState().administration.transporteurs.isPatching) {
        return;
    }
    return dispatch(_postTransporteurCompte(transporteur, transporteurCompte));
};

const _postTransporteurCompte = (transporteur, transporteurCompte) => async (dispatch) => {

    dispatch(postTransporteurCompteRequest());

    let params = {
        ...transporteurCompte
    };

    try {
        let response = await axios.post(`api/transporteurs/${transporteur.id}/comptes`, params);
        dispatch(postTransporteurCompteSuccess(response.data));
        dispatch(addNotification(`Le compte ${transporteurCompte.compte} a bien été ajouté au transporteur ${transporteur.code}.`, NotificationImportance.success));
    } catch (error) {
        console.error('_postTransporteurCompte : ', error);
        dispatch(postTransporteurCompteFailure(error));
        dispatch(addNotification(`Impossible d'ajouter le compte au transporteur ${transporteur.code}.`, NotificationImportance.error));
    }
};

/**
 * DELETE_TRANSPORTEUR_COMPTE_
 * ActionCreator pour la suppression d'un transporteurCompte
 */
const deleteTransporteurCompteRequest = (transporteurId, transporteurCompteId) => ({ type: Actions.DELETE_TRANSPORTEUR_COMPTE_REQUEST, transporteurId, transporteurCompteId });
const deleteTransporteurCompteSuccess = (transporteurId, transporteurCompteId) => ({ type: Actions.DELETE_TRANSPORTEUR_COMPTE_SUCCESS, transporteurId, transporteurCompteId });
const deleteTransporteurCompteFailure = error => ({ type: Actions.DELETE_TRANSPORTEUR_COMPTE_FAILURE, error });

export const deleteTransporteurCompte = (transporteurId, transporteurCompteId) => (dispatch, getState) => {
    if (getState().administration.transporteurs.isLoading || getState().administration.transporteurs.isPatching) {
        return;
    }
    return dispatch(_deleteTransporteurCompte(transporteurId, transporteurCompteId));
};

const _deleteTransporteurCompte = (transporteurId, transporteurCompteId) => async (dispatch) => {

    dispatch(deleteTransporteurCompteRequest(transporteurId, transporteurCompteId));

    try {
        let response = await axios.delete(`api/transporteurs/${transporteurId}/comptes/${transporteurCompteId}`);
        dispatch(deleteTransporteurCompteSuccess(response.data.transporteurId, response.data.transporteurCompteId ));
        dispatch(addNotification(`Le compte ${response.data.transporteurCompteId} a bien été supprimé du transporteur ${response.data.transporteurId}.`, NotificationImportance.success));
    } catch (error) {
        console.error('_deleteTransporteurCompte : ', error);
        dispatch(deleteTransporteurCompteFailure(error));
        dispatch(addNotification(`Impossible de supprimer le compte ${transporteurCompteId} du transporteur ${transporteurId}.`, NotificationImportance.error));
    }
};

/**
 * PATCH_TRANSPORTEUR_COMPTE
 * ActionCreator pour la modification d'un transporteurCompte
 */
const patchTransporteurCompteRequest = () => ({ type: Actions.PATCH_TRANSPORTEUR_COMPTE_REQUEST });
const patchTransporteurCompteSuccess = (payload) => ({ type: Actions.PATCH_TRANSPORTEUR_COMPTE_SUCCESS, payload });
const patchTransporteurCompteFailure = error => ({ type: Actions.PATCH_TRANSPORTEUR_COMPTE_FAILURE, error });

export const patchTransporteurCompte = (transporteurId, transporteurCompte) => (dispatch, getState) => {
    if (getState().administration.transporteurs.isLoading || getState().administration.transporteurs.isPatching) {
        return;
    }
    return dispatch(_patchTransporteurCompte(transporteurId, transporteurCompte));
};

const _patchTransporteurCompte = (transporteurId, transporteurCompte) => async (dispatch) => {

    dispatch(patchTransporteurCompteRequest());
    
    let params = {
        compte: transporteurCompte.compte,
        login: transporteurCompte.login,
        motPasse: transporteurCompte.motPasse,
        email: transporteurCompte.email,
        defaut: transporteurCompte.defaut,
        codesDepot: transporteurCompte.depotsGestion.map(x => x.codeDepot)
    };
       
    try {
        let response = await axios.patch(`api/transporteurs/${transporteurId}/comptes/${transporteurCompte.id}`, params);

        dispatch(patchTransporteurCompteSuccess( response.data ));
        dispatch(addNotification(`Le transporteur compte ${transporteurCompte.id} a bien été modifié.`, NotificationImportance.success));
    } catch (error) {
        console.error('_patchTransporteurCompte : ', error);
        dispatch(patchTransporteurCompteFailure(error));
        dispatch(addNotification(`Impossible de modifier le transporteur compte ${transporteurCompte.code}.`, NotificationImportance.error));
    }
};

/**
 * SET_DEFAUT_TRANSPORTEUR_COMPTE_
 * ActionCreator pour la modification d'un transporteurCompte > defaut sur le transporteur
 */
const setDefautTransporteurCompteRequest = () => ({ type: Actions.SET_DEFAUT_TRANSPORTEUR_COMPTE_REQUEST });
const setDefautTransporteurCompteSuccess = (payload) => ({ type: Actions.SET_DEFAUT_TRANSPORTEUR_COMPTE_SUCCESS, payload });
const setDefautTransporteurCompteFailure = error => ({ type: Actions.SET_DEFAUT_TRANSPORTEUR_COMPTE_FAILURE, error });

export const setDefautTransporteurCompte = (transporteurId, transporteurCompteId) => (dispatch, getState) => {
    if (getState().administration.transporteurs.isLoading || getState().administration.transporteurs.isPatching) {
        return;
    }
    return dispatch(_setDefautTransporteurCompte(transporteurId, transporteurCompteId));
};

const _setDefautTransporteurCompte = (transporteurId, transporteurCompteId) => async (dispatch) => {

    dispatch(setDefautTransporteurCompteRequest());
    
    try {
        let response = await axios.patch(`api/transporteurs/${transporteurId}/comptes/${transporteurCompteId}/set-defaut`);

        dispatch(setDefautTransporteurCompteSuccess(response.data));
        dispatch(addNotification(`Le transporteur compte ${transporteurCompteId} a bien été modifié comme compte par défaut pour le transporteur ${transporteurId}.`, NotificationImportance.success));
    } catch (error) {
        console.error('_setDefautTransporteurCompte : ', error);
        dispatch(setDefautTransporteurCompteFailure(error));
        dispatch(addNotification(`Impossible de modifier le transporteur compte ${transporteurCompteId} comme compte par défaut pour le transporteur ${transporteurId}.`, NotificationImportance.error));
    }
};

/**
 * FETCH_ADMINISTRATION_MOTIFS_RESOLUTION
 * ActionCreator pour la récupération des motifs de résolutions pour l'administration
 */
const fetchAdministrationMotifsResolutionRequest = param => ({ type: Actions.FETCH_ADMINISTRATION_MOTIFS_RESOLUTION_REQUEST, param });
const fetchAdministrationMotifsResolutionSuccess = items => ({ type: Actions.FETCH_ADMINISTRATION_MOTIFS_RESOLUTION_SUCCESS, items });
const fetchAdministrationMotifsResolutionFailure = error => ({ type: Actions.FETCH_ADMINISTRATION_MOTIFS_RESOLUTION_FAILURE, error });

export const fetchAdministrationMotifsResolution = (param) => (dispatch, getState) => {

    if (getState().administration.motifsResolution.isLoading || getState().administration.motifsResolution.isPatching) {
        return;
    }

    if ((getState().administration.motifsResolution.items.length > 0) && (!param.avecNbActions || (param.avecNbActions && getState().administration.motifsResolution.avecNbActions))) {
        return;
    }
    return dispatch(_fetchAdministrationMotifsResolution(param));
};

const _fetchAdministrationMotifsResolution = (param) => async (dispatch) => {

    dispatch(fetchAdministrationMotifsResolutionRequest(param));

    try {
        let response = await axios.get('api/motifs-resolution/administration', { params: param, paramsSerializer: axiosHelper.transformRequestOptions });
        dispatch(fetchAdministrationMotifsResolutionSuccess(response.data));
    } catch (error) {
        console.error('fetchAdministrationMotifsResolution : ', error);
        dispatch(fetchAdministrationMotifsResolutionFailure(error));
    }
};

/**
 * PATCH_MOTIF_RESOLUTION_
 * ActionCreator pour la modification d'un motif de résolution
 */
const patchMotifResolutionRequest = motifResolution => ({ type: Actions.PATCH_MOTIF_RESOLUTION_REQUEST, motifResolution });
const patchMotifResolutionSuccess = motifResolution => ({ type: Actions.PATCH_MOTIF_RESOLUTION_SUCCESS, motifResolution });
const patchMotifResolutionFailure = error => ({ type: Actions.PATCH_MOTIF_RESOLUTION_FAILURE, error });

export const patchMotifResolution = (motifResolution) => (dispatch, getState) => {
    if (getState().administration.motifsResolution.isLoading || getState().administration.motifsResolution.isPatching) {
        return;
    }
    return dispatch(_patchMotifResolution(motifResolution));
};

const _patchMotifResolution = (motifResolution) => async (dispatch) => {

    dispatch(patchMotifResolutionRequest(motifResolution));

    let params = {
        libelle: motifResolution.libelle
    };

    try {
        let response = await axios.patch(`api/motifs-resolution/${motifResolution.id}`, params);
        dispatch(patchMotifResolutionSuccess(response.data));
        dispatch(addNotification(`Le motif de résolution ${motifResolution.code} a bien été modifié.`, NotificationImportance.success));
    } catch (error) {
        console.error('_patchMotifResolution : ', error);
        dispatch(patchMotifResolutionFailure(error));
        dispatch(addNotification(`Impossible de modifier le motif de résolution ${motifResolution.code}.`, NotificationImportance.error));
    }
};

/**
 * POST_MOTIF_RESOLUTION_
 * ActionCreator pour la création d'un motif de résolution
 */
const postMotifResolutionRequest = motifResolution => ({ type: Actions.POST_MOTIF_RESOLUTION_REQUEST, motifResolution });
const postMotifResolutionSuccess = motifResolution => ({ type: Actions.POST_MOTIF_RESOLUTION_SUCCESS, motifResolution });
const postMotifResolutionFailure = error => ({ type: Actions.POST_MOTIF_RESOLUTION_FAILURE, error });

export const postMotifResolution = (motifResolution) => (dispatch, getState) => {
    if (getState().administration.motifsResolution.isLoading || getState().administration.motifsResolution.isPatching) {
        return;
    }
    return dispatch(_postMotifResolution(motifResolution));
};

const _postMotifResolution = (motifResolution) => async (dispatch) => {

    dispatch(postMotifResolutionRequest(motifResolution));

    let params = {
        code: motifResolution.code,
        libelle: motifResolution.libelle
    };

    try {
        let response = await axios.post(`api/motifs-resolution`, params);
        dispatch(postMotifResolutionSuccess(response.data));
        dispatch(addNotification(`Le motif de résolution ${motifResolution.code} a bien été ajouté.`, NotificationImportance.success));
    } catch (error) {
        console.error('_postMotifResolution : ', error);
        dispatch(postMotifResolutionFailure(error));
        dispatch(addNotification(`Impossible d'ajouter le motif de résolution ${motifResolution.code}.`, NotificationImportance.error));
    }
};

/**
 * DELETE_MOTIF_RESOLUTION_
 * ActionCreator pour la suppression d'un motif de résolution
 */
const deleteMotifResolutionRequest = motifResolutionId => ({ type: Actions.DELETE_MOTIF_RESOLUTION_REQUEST, motifResolutionId });
const deleteMotifResolutionSuccess = motifResolutionId => ({ type: Actions.DELETE_MOTIF_RESOLUTION_SUCCESS, motifResolutionId });
const deleteMotifResolutionFailure = error => ({ type: Actions.DELETE_MOTIF_RESOLUTION_FAILURE, error });

export const deleteMotifResolution = (motifResolutionId) => (dispatch, getState) => {
    if (getState().administration.motifsResolution.isLoading || getState().administration.motifsResolution.isPatching) {
        return;
    }
    return dispatch(_deleteMotifResolution(motifResolutionId));
};

const _deleteMotifResolution = (motifResolutionId) => async (dispatch) => {

    dispatch(deleteMotifResolutionRequest(motifResolutionId));

    try {
        let response = await axios.delete(`api/motifs-resolution/${motifResolutionId}`);
        dispatch(deleteMotifResolutionSuccess(response.data));
        dispatch(addNotification(`Le motif de résolution ${motifResolutionId} a bien été supprimé.`, NotificationImportance.success));
    } catch (error) {
        console.error('_deleteMotifResolution : ', error);
        dispatch(deleteMotifResolutionFailure(error));
        dispatch(addNotification(`Impossible de supprimer le motif de résolution ${motifResolutionId}.`, NotificationImportance.error));
    }
};

/**
 * FETCH_ADMINISTRATION_CAUSES_PRINCIPALES
 * ActionCreator pour la récupération des causes principales pour l'administration
 */
const fetchAdministrationCausesPrincipalesRequest = param => ({ type: Actions.FETCH_ADMINISTRATION_CAUSES_PRINCIPALES_REQUEST, param });
const fetchAdministrationCausesPrincipalesSuccess = items => ({ type: Actions.FETCH_ADMINISTRATION_CAUSES_PRINCIPALES_SUCCESS, items });
const fetchAdministrationCausesPrincipalesFailure = error => ({ type: Actions.FETCH_ADMINISTRATION_CAUSES_PRINCIPALES_FAILURE, error });

export const fetchAdministrationCausesPrincipales = (param) => (dispatch, getState) => {

    if (getState().administration.causesPrincipales.isLoading || getState().administration.causesPrincipales.isPatching) {
        return;
    }
    if ((getState().administration.causesPrincipales.items.length > 0) && (!param.avecNbActions || (param.avecNbActions && getState().administration.causesPrincipales.avecNbActions))) {
        return;
    }
    return dispatch(_fetchAdministrationCausesPrincipales(param));
};

const _fetchAdministrationCausesPrincipales = (param) => async (dispatch) => {

    dispatch(fetchAdministrationCausesPrincipalesRequest(param));

    try {
        let response = await axios.get('api/causes-principales/administration', { params: param, paramsSerializer: axiosHelper.transformRequestOptions });
        dispatch(fetchAdministrationCausesPrincipalesSuccess(response.data));
    } catch (error) {
        console.error('fetchAdministrationCausesPrincipales : ', error);
        dispatch(fetchAdministrationCausesPrincipalesFailure(error));
    }
};

/**
 * PATCH_CAUSE_PRINCIPALE_
 * ActionCreator pour la modification d'un cause principale
 */
const patchCausePrincipaleRequest = causePrincipale => ({ type: Actions.PATCH_CAUSE_PRINCIPALE_REQUEST, causePrincipale });
const patchCausePrincipaleSuccess = causePrincipale => ({ type: Actions.PATCH_CAUSE_PRINCIPALE_SUCCESS, causePrincipale });
const patchCausePrincipaleFailure = error => ({ type: Actions.PATCH_CAUSE_PRINCIPALE_FAILURE, error });

export const patchCausePrincipale = (causePrincipale) => (dispatch, getState) => {
    if (getState().administration.causesPrincipales.isLoading || getState().administration.causesPrincipales.isPatching) {
        return;
    }
    return dispatch(_patchCausePrincipale(causePrincipale));
};

const _patchCausePrincipale = (causePrincipale) => async (dispatch) => {

    dispatch(patchCausePrincipaleRequest(causePrincipale));

    let params = {
        libelle: causePrincipale.libelle,
        details: causePrincipale.details
    };

    try {
        let response = await axios.patch(`api/causes-principales/${causePrincipale.id}`, params);
        dispatch(patchCausePrincipaleSuccess(response.data));
        dispatch(addNotification(`La cause principale ${causePrincipale.code} a bien été modifié.`, NotificationImportance.success));
    } catch (error) {
        console.error('_patchCausePrincipale : ', error);
        dispatch(patchCausePrincipaleFailure(error));
        dispatch(addNotification(`Impossible de modifier la cause principale ${causePrincipale.code}.`, NotificationImportance.error));
    }

};

/**
 * POST_CAUSE_PRINCIPALE_
 * ActionCreator pour la création d'une cause principale
 */
const postCausePrincipaleRequest = causePrincipale => ({ type: Actions.POST_CAUSE_PRINCIPALE_REQUEST, causePrincipale });
const postCausePrincipaleSuccess = causePrincipale => ({ type: Actions.POST_CAUSE_PRINCIPALE_SUCCESS, causePrincipale });
const postCausePrincipaleFailure = error => ({ type: Actions.POST_CAUSE_PRINCIPALE_FAILURE, error });

export const postCausePrincipale = (causePrincipale) => (dispatch, getState) => {
    if (getState().administration.causesPrincipales.isLoading || getState().administration.causesPrincipales.isPatching) {
        return;
    }
    return dispatch(_postCausePrincipale(causePrincipale));
};

const _postCausePrincipale = (causePrincipale) => async (dispatch) => {

    dispatch(postCausePrincipaleRequest(causePrincipale));

    let params = {
        code: causePrincipale.code,
        libelle: causePrincipale.libelle
    };

    try {
        let response = await axios.post(`api/causes-principales`, params);
        dispatch(postCausePrincipaleSuccess(response.data));
        dispatch(addNotification(`La cause principale ${causePrincipale.code} a bien été ajouté.`, NotificationImportance.success));
    } catch (error) {
        console.error('_postCausePrincipale : ', error);
        dispatch(postCausePrincipaleFailure(error));
        dispatch(addNotification(`Impossible d'ajouter la cause principale ${causePrincipale.code}.`, NotificationImportance.error));
    }
};

/**
 * DELETE_CAUSE_PRINCIPALE_
 * ActionCreator pour la suppression d'une cause principale
 */
const deleteCausePrincipaleRequest = causePrincipaleId => ({ type: Actions.DELETE_CAUSE_PRINCIPALE_REQUEST, causePrincipaleId });
const deleteCausePrincipaleSuccess = causePrincipaleId => ({ type: Actions.DELETE_CAUSE_PRINCIPALE_SUCCESS, causePrincipaleId });
const deleteCausePrincipaleFailure = error => ({ type: Actions.DELETE_CAUSE_PRINCIPALE_FAILURE, error });

export const deleteCausePrincipale = (causePrincipaleId) => (dispatch, getState) => {
    if (getState().administration.causesPrincipales.isLoading || getState().administration.causesPrincipales.isPatching) {
        return;
    }
    return dispatch(_deleteCausePrincipale(causePrincipaleId));
};

const _deleteCausePrincipale = (causePrincipaleId) => async (dispatch) => {

    dispatch(deleteCausePrincipaleRequest(causePrincipaleId));

    try {
        let response = await axios.delete(`api/causes-principales/${causePrincipaleId}`);
        dispatch(deleteCausePrincipaleSuccess(response.data));
        dispatch(addNotification(`La cause principale ${causePrincipaleId} a bien été supprimé.`, NotificationImportance.success));
    } catch (error) {
        console.error('_deleteCausePrincipale : ', error);
        dispatch(deleteCausePrincipaleFailure(error));
        dispatch(addNotification(`Impossible de supprimer la cause principale ${causePrincipaleId}.`, NotificationImportance.error));
    }
};

/**
 * ActionCreator pour récupérer les informations des clients prioritaires
 */
const fetchAdministrationClientsPrioritairesRequest = (fichierId) => ({ type: Actions.FETCH_CLIENTS_PRIORITAIRES_REQUEST, fichierId });
const fetchAdministrationClientsPrioritairesSuccess = (items) => ({ type: Actions.FETCH_CLIENTS_PRIORITAIRES_SUCCESS, items });
const fetchAdministrationClientsPrioritairesFailure = (error) => ({ type: Actions.FETCH_CLIENTS_PRIORITAIRES_FAILURE, error });

export const fetchAdministrationClientsPrioritaires = (fichierId) => async (dispatch, getState) => {
    if (!getState().administration.clients.prioritaires.isLoading) {

        dispatch(fetchAdministrationClientsPrioritairesRequest(fichierId));

        let params = {
            fichierId: fichierId
        };

        try {
            let response = await axios.get('api/clients/prioritaires', { params: params, paramsSerializer: axiosHelper.transformRequestOptions });

            dispatch(fetchAdministrationClientsPrioritairesSuccess(response.data));

        } catch (error) {
            console.error('fetchAdministrationClientsPrioritaires : ', error);
            dispatch(fetchAdministrationClientsPrioritairesFailure(error));
        }
    }
};

/**
 * ActionCreator pour CLEAR_CLIENTS_PRIORITAIRES
 */
export const clearClientsPrioritaires = () => ({ type: Actions.CLEAR_CLIENTS_PRIORITAIRES });

/**
 * ActionCreator pour récupérer l'import des clients prioritaires
 */
const importClientsPrioritairesRequest = () => ({ type: Actions.IMPORT_CLIENTS_PRIORITAIRES_REQUEST });
const importClientsPrioritairesSuccess = (importResult) => ({ type: Actions.IMPORT_CLIENTS_PRIORITAIRES_SUCCESS, importResult });
const importClientsPrioritairesFailure = (error) => ({ type: Actions.IMPORT_CLIENTS_PRIORITAIRES_FAILURE, error });

export const importClientsPrioritaires = (clientsPrioritaires) => async (dispatch, getState) => {

    if (!getState().administration.clients.prioritaires.isAdding) {

        dispatch(importClientsPrioritairesRequest());

        let param = {
            clients: clientsPrioritaires
        };

        try {
            let response = await axios.post(`api/clients/importer-prioritaires`, param);

            dispatch(importClientsPrioritairesSuccess(response.data));

        } catch (error) {
            console.error('importClientsPrioritaires : ', error);
            dispatch(importClientsPrioritairesFailure(error));
        }
    }
};

export const exportClientsPrioritaires = () => async (dispatch) => {

    try {
        let response = await axios.get(`api/clients/exporter-prioritaires`, { responseType: 'arraybuffer' });

        var contentType = response.headers['content-type'];

        const url = window.URL.createObjectURL(new File([response.data], { type: contentType }));
        const link = document.createElement('a');
        link.href = url;

        var contentDisposition = response.headers['content-disposition'];
        var regex = new RegExp("filename[^;=\\n]*=['\"]?(?:UTF-\\d['\"]*)?([^;\\r\\n\"']*)['\"]?;?"); // https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header

        var match = regex.exec(contentDisposition);

        let filename = match[1]; // On prend le groupe 1

        link.setAttribute('download', decodeURIComponent(filename));

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);


    } catch (error) {
        dispatch(addNotification(`Impossible de télécharger le fichier des clients prioritaires`, NotificationImportance.error, true));
    }
};

/**
 * PATCH_CLIENT_
 * ActionCreator pour la modification d'un client
 */
const patchClientRequest = client => ({ type: Actions.PATCH_CLIENT_REQUEST, client });
const patchClientSuccess = client => ({ type: Actions.PATCH_CLIENT_SUCCESS, client });
const patchClientFailure = error => ({ type: Actions.PATCH_CLIENT_FAILURE, error });

export const patchClient = (client) => (dispatch, getState) => {
    if (getState().administration.clients.isPatching) {
        return;
    }
    return dispatch(_patchClient(client));
};

const _patchClient = (client) => async (dispatch) => {

    dispatch(patchClientRequest(client));

    let params = {
        autoriseNotificationSouffranceTransporteur: client.autoriseNotificationSouffranceTransporteur,
        prioritaire: client.prioritaire,
        pctJokerFraisRetour: client.pctJokerFraisRetour.replace('.', ',')
    };

    try {
        let response = await axios.patch(`api/clients/${client.id}`, params);
        dispatch(patchClientSuccess(response.data));
        dispatch(addNotification(`Le client ${client.code} - ${client.libelle} a bien été modifié.`, NotificationImportance.success));
    } catch (error) {
        console.error('_patchClient error : ', error);
        dispatch(patchClientFailure(error));
        dispatch(addNotification(`Impossible de modifier le client ${client.code} - ${client.libelle}.`, NotificationImportance.error));
    }
};

/**
 * PATCH_FOURNISSEUR_
 * ActionCreator pour la modification d'un Fournisseur
 */
const patchFournisseurRequest = fournisseur => ({ type: Actions.PATCH_FOURNISSEUR_REQUEST, fournisseur });
const patchFournisseurSuccess = fournisseur => ({ type: Actions.PATCH_FOURNISSEUR_SUCCESS, fournisseur });
const patchFournisseurFailure = error => ({ type: Actions.PATCH_FOURNISSEUR_FAILURE, error });

export const patchFournisseur = (fournisseur) => (dispatch, getState) => {
    if (getState().administration.fournisseurs.isPatching) {
        return;
    }
    return dispatch(_patchFournisseur(fournisseur));
};

const _patchFournisseur = (fournisseur) => async (dispatch) => {
    dispatch(patchFournisseurRequest(fournisseur));

    let params = {
        autoriseSAVPlateformeLogistique: fournisseur.autoriseSAVPlateformeLogistique,
        autoriseSAV: fournisseur.autoriseSAV
    };

    try {
        let response = await axios.patch(`api/fournisseurs/${fournisseur.id}`, params);
        dispatch(patchFournisseurSuccess(response.data));
        dispatch(addNotification(`Le fournisseur ${fournisseur.code} - ${fournisseur.nom} a bien été modifié.`, NotificationImportance.success));
    } catch (error) {
        console.error('_patchFournisseur error : ', error);
        dispatch(patchFournisseurFailure(error));
        dispatch(addNotification(`Impossible de modifier le fournisseur ${fournisseur.code} - ${fournisseur.nom}.`, NotificationImportance.error));
    }
};

/**
 * FETCH_ADMINISTRATION_FRAIS_RETOUR_EXCLUS
 * ActionCreator pour la récupération des fraisRetourExclus pour l'administration
 */
const fetchAdministrationFraisRetourExclusRequest = () => ({ type: Actions.FETCH_ADMINISTRATION_FRAIS_RETOUR_EXCLUS_REQUEST });
const fetchAdministrationFraisRetourExclusSuccess = items => ({ type: Actions.FETCH_ADMINISTRATION_FRAIS_RETOUR_EXCLUS_SUCCESS, items });
const fetchAdministrationFraisRetourExclusFailure = error => ({ type: Actions.FETCH_ADMINISTRATION_FRAIS_RETOUR_EXCLUS_FAILURE, error });

export const fetchAdministrationFraisRetourExclus = () => (dispatch, getState) => {
    if (getState().administration.fraisRetourExclus.isLoading || getState().administration.fraisRetourExclus.isPatching) {
        return;
    }
    if (getState().administration.fraisRetourExclus.items.length > 0) {
        return;
    }
    return dispatch(_fetchAdministrationFraisRetourExclus());
};

const _fetchAdministrationFraisRetourExclus = () => async (dispatch) => {

    dispatch(fetchAdministrationFraisRetourExclusRequest());

    try {
        let response = await axios.get('api/fraisRetourExclus/administration');
        dispatch(fetchAdministrationFraisRetourExclusSuccess(response.data));
    } catch (error) {
        console.error('fetchAdministrationFraisRetourExclus : ', error);
        dispatch(fetchAdministrationFraisRetourExclusFailure(error));
    }
};

/**
 * ActionCreator pour la récupération du pourcentage général pour le joker des frais de retour.
 */
export const getPctJokerFraisRetour = () => async () => {
    try {
        let response = await axios.get(`api/parametres/${ParametreCodes.PctJokerFraisRetour}`);

        return response.data;
    } catch (error) {
        console.error('fetchAdministrationPctJokerFraisRetour : ', error);
    }
};

export const patchPctJokerFraisRetour = (pctJokerFraisRetour) => async (dispatch, getState) => {
    let params = {
        valeur: pctJokerFraisRetour.replace('.', ',')
    };

    try {
        let response = await axios.patch(`api/parametres/${ParametreCodes.PctJokerFraisRetour}`, params);

        if (response.status === 200) {
            dispatch(addNotification(`Mise à jour du paramètre réussie`, NotificationImportance.success));
        } else {
            dispatch(addNotification(`Impossible de mettre à jour le paramètre. Code retour:`, response.status));
        }
        
    } catch (error) {
        console.error('_postFraisRetourExclu : ', error);
        dispatch(addNotification(`Impossible de mettre à jour le paramètre`, NotificationImportance.error));
    }
};

/**
 * POST_FRAIS_RETOUR_EXCLU_
 * ActionCreator pour la création d'un fraisRetourExclu
 */
const postFraisRetourExcluRequest = fraisRetourExclu => ({ type: Actions.POST_FRAIS_RETOUR_EXCLU_REQUEST, fraisRetourExclu });
const postFraisRetourExcluSuccess = fraisRetourExclu => ({ type: Actions.POST_FRAIS_RETOUR_EXCLU_SUCCESS, fraisRetourExclu });
const postFraisRetourExcluFailure = error => ({ type: Actions.POST_FRAIS_RETOUR_EXCLU_FAILURE, error });

export const postFraisRetourExclu = (fraisRetourExclu) => (dispatch, getState) => {
    if (getState().administration.fraisRetourExclus.isLoading || getState().administration.fraisRetourExclus.isPatching) {
        return;
    }
    return dispatch(_postFraisRetourExclu(fraisRetourExclu));
};

const _postFraisRetourExclu = (fraisRetourExclu) => async (dispatch, getState) => {
    dispatch(postFraisRetourExcluRequest(fraisRetourExclu));

    let params = {
        niveau: fraisRetourExclu.niveau,
        code: fraisRetourExclu.code,
        profilPO: fraisRetourExclu.profilPO
    };

    let niveau = getState().administration.fraisRetourExclus.niveaux.find(x => x.id === fraisRetourExclu.niveau);

    try {
        let response = await axios.post(`api/fraisRetourExclus/`, params);
        dispatch(postFraisRetourExcluSuccess(response.data));
        dispatch(addNotification(`L'exclusion pour le niveau "${niveau.libelle}" et le code "${fraisRetourExclu.code}", a bien été ajoutée.`, NotificationImportance.success));
    } catch (error) {
        console.error('_postFraisRetourExclu : ', error);
        dispatch(postFraisRetourExcluFailure(error));
        dispatch(addNotification(`Impossible d'ajouter l'exclusion pour le niveau "${niveau.libelle}" et le code "${fraisRetourExclu.code}".`, NotificationImportance.error));
    }

};

/**
 * DELETE_FRAIS_RETOUR_EXCLU_
 * ActionCreator pour la suppression d'un fraisRetourExclu
 */
const deleteFraisRetourExcluRequest = fraisRetourExcluId => ({ type: Actions.DELETE_FRAIS_RETOUR_EXCLU_REQUEST, fraisRetourExcluId });
const deleteFraisRetourExcluSuccess = fraisRetourExcluId => ({ type: Actions.DELETE_FRAIS_RETOUR_EXCLU_SUCCESS, fraisRetourExcluId });
const deleteFraisRetourExcluFailure = error => ({ type: Actions.DELETE_FRAIS_RETOUR_EXCLU_FAILURE, error });

export const deleteFraisRetourExclu = (fraisRetourExcluId) => (dispatch, getState) => {
    if (getState().administration.fraisRetourExclus.isLoading || getState().administration.fraisRetourExclus.isPatching) {
        return;
    }
    return dispatch(_deleteFraisRetourExclu(fraisRetourExcluId));
};

const _deleteFraisRetourExclu = (fraisRetourExcluId) => async (dispatch) => {

    dispatch(deleteFraisRetourExcluRequest(fraisRetourExcluId));

    try {
        let response = await axios.delete(`api/fraisRetourExclus/${fraisRetourExcluId}`);
        dispatch(deleteFraisRetourExcluSuccess(response.data));
        dispatch(addNotification(`Le fraisRetourExclu ${fraisRetourExcluId} a bien été supprimé.`, NotificationImportance.success));
    } catch (error) {
        console.error('_deleteFraisRetourExclu : ', error);
        dispatch(deleteFraisRetourExcluFailure(error));
        dispatch(addNotification(`Impossible de supprimer le fraisRetourExclu ${fraisRetourExcluId}.`, NotificationImportance.error));
    }
};





/**
 * FETCH_ADMINISTRATION_DECOTE_RETOUR_EXCLUS
 * ActionCreator pour la récupération des decoteRetourExclus pour l'administration
 */
const fetchAdministrationDecoteRetourExclusRequest = () => ({ type: Actions.FETCH_ADMINISTRATION_DECOTE_RETOUR_EXCLUS_REQUEST });
const fetchAdministrationDecoteRetourExclusSuccess = items => ({ type: Actions.FETCH_ADMINISTRATION_DECOTE_RETOUR_EXCLUS_SUCCESS, items });
const fetchAdministrationDecoteRetourExclusFailure = error => ({ type: Actions.FETCH_ADMINISTRATION_DECOTE_RETOUR_EXCLUS_FAILURE, error });

export const fetchAdministrationDecoteRetourExclus = () => (dispatch, getState) => {
    if (getState().administration.decoteRetourExclus.isLoading || getState().administration.decoteRetourExclus.isPatching) {
        return;
    }
    if (getState().administration.decoteRetourExclus.items.length > 0) {
        return;
    }
    return dispatch(_fetchAdministrationDecoteRetourExclus());
};

const _fetchAdministrationDecoteRetourExclus = () => async (dispatch) => {

    dispatch(fetchAdministrationDecoteRetourExclusRequest());

    try {
        let response = await axios.get('api/decoteRetourExclus/administration');
        dispatch(fetchAdministrationDecoteRetourExclusSuccess(response.data));
    } catch (error) {
        console.error('fetchAdministrationDecoteRetourExclus : ', error);
        dispatch(fetchAdministrationDecoteRetourExclusFailure(error));
    }
};


/**
 * POST_DECOTE_RETOUR_EXCLU_
 * ActionCreator pour la création d'un decoteRetourExclu
 */
const postDecoteRetourExcluRequest = decoteRetourExclu => ({ type: Actions.POST_DECOTE_RETOUR_EXCLU_REQUEST, decoteRetourExclu });
const postDecoteRetourExcluSuccess = decoteRetourExclu => ({ type: Actions.POST_DECOTE_RETOUR_EXCLU_SUCCESS, decoteRetourExclu });
const postDecoteRetourExcluFailure = error => ({ type: Actions.POST_DECOTE_RETOUR_EXCLU_FAILURE, error });

export const postDecoteRetourExclu = (decoteRetourExclu) => (dispatch, getState) => {
    if (getState().administration.decoteRetourExclus.isLoading || getState().administration.decoteRetourExclus.isPatching) {
        return;
    }
    return dispatch(_postDecoteRetourExclu(decoteRetourExclu));
};

const _postDecoteRetourExclu = (decoteRetourExclu) => async (dispatch, getState) => {
    dispatch(postDecoteRetourExcluRequest(decoteRetourExclu));

    let params = {
        niveau: decoteRetourExclu.niveau,
        code: decoteRetourExclu.code,
        profilPO: decoteRetourExclu.profilPO
    };

    let niveau = getState().administration.decoteRetourExclus.niveaux.find(x => x.id === decoteRetourExclu.niveau);

    try {
        let response = await axios.post(`api/decoteRetourExclus/`, params);
        dispatch(postDecoteRetourExcluSuccess(response.data));
        dispatch(addNotification(`L'exclusion pour le niveau "${niveau.libelle}" et le code "${decoteRetourExclu.code}", a bien été ajoutée.`, NotificationImportance.success));
    } catch (error) {
        console.error('_postDecoteRetourExclu : ', error);
        dispatch(postDecoteRetourExcluFailure(error));
        dispatch(addNotification(`Impossible d'ajouter l'exclusion pour le niveau "${niveau.libelle}" et le code "${decoteRetourExclu.code}".`, NotificationImportance.error));
    }

};

/**
 * DELETE_DECOTE_RETOUR_EXCLU_
 * ActionCreator pour la suppression d'un decoteRetourExclu
 */
const deleteDecoteRetourExcluRequest = decoteRetourExcluId => ({ type: Actions.DELETE_DECOTE_RETOUR_EXCLU_REQUEST, decoteRetourExcluId });
const deleteDecoteRetourExcluSuccess = decoteRetourExcluId => ({ type: Actions.DELETE_DECOTE_RETOUR_EXCLU_SUCCESS, decoteRetourExcluId });
const deleteDecoteRetourExcluFailure = error => ({ type: Actions.DELETE_DECOTE_RETOUR_EXCLU_FAILURE, error });

export const deleteDecoteRetourExclu = (decoteRetourExcluId) => (dispatch, getState) => {
    if (getState().administration.decoteRetourExclus.isLoading || getState().administration.decoteRetourExclus.isPatching) {
        return;
    }
    return dispatch(_deleteDecoteRetourExclu(decoteRetourExcluId));
};

const _deleteDecoteRetourExclu = (decoteRetourExcluId) => async (dispatch) => {

    dispatch(deleteDecoteRetourExcluRequest(decoteRetourExcluId));

    try {
        let response = await axios.delete(`api/decoteRetourExclus/${decoteRetourExcluId}`);
        dispatch(deleteDecoteRetourExcluSuccess(response.data));
        dispatch(addNotification(`Le decoteRetourExclu ${decoteRetourExcluId} a bien été supprimé.`, NotificationImportance.success));
    } catch (error) {
        console.error('_deleteDecoteRetourExclu : ', error);
        dispatch(deleteDecoteRetourExcluFailure(error));
        dispatch(addNotification(`Impossible de supprimer le decoteRetourExclu ${decoteRetourExcluId}.`, NotificationImportance.error));
    }
};









/**
 * FETCH_ADMINISTRATION_RETOUR_EXCLUS
 * ActionCreator pour la récupération des retourExclus pour l'administration
 */
const fetchAdministrationRetourExclusRequest = () => ({ type: Actions.FETCH_ADMINISTRATION_RETOUR_EXCLUS_REQUEST });
const fetchAdministrationRetourExclusSuccess = items => ({ type: Actions.FETCH_ADMINISTRATION_RETOUR_EXCLUS_SUCCESS, items });
const fetchAdministrationRetourExclusFailure = error => ({ type: Actions.FETCH_ADMINISTRATION_RETOUR_EXCLUS_FAILURE, error });

export const fetchAdministrationRetourExclus = () => (dispatch, getState) => {
    if (getState().administration.retourExclus.isLoading || getState().administration.retourExclus.isPatching) {
        return;
    }
    if (getState().administration.retourExclus.items.length > 0) {
        return;
    }
    return dispatch(_fetchAdministrationRetourExclus());
};

const _fetchAdministrationRetourExclus = () => async (dispatch) => {

    dispatch(fetchAdministrationRetourExclusRequest());

    try {
        let response = await axios.get('api/retourExclus/administration');
        dispatch(fetchAdministrationRetourExclusSuccess(response.data));
    } catch (error) {
        console.error('fetchAdministrationRetourExclus : ', error);
        dispatch(fetchAdministrationRetourExclusFailure(error));
    }
};

/**
 * POST_RETOUR_EXCLU_
 * ActionCreator pour la création d'un retourExclu
 */
const postRetourExcluRequest = retourExclu => ({ type: Actions.POST_RETOUR_EXCLU_REQUEST, retourExclu });
const postRetourExcluSuccess = retourExclu => ({ type: Actions.POST_RETOUR_EXCLU_SUCCESS, retourExclu });
const postRetourExcluFailure = error => ({ type: Actions.POST_RETOUR_EXCLU_FAILURE, error });

export const postRetourExclu = (retourExclu) => (dispatch, getState) => {
    if (getState().administration.retourExclus.isLoading || getState().administration.retourExclus.isPatching) {
        return;
    }
    return dispatch(_postRetourExclu(retourExclu));
};

const _postRetourExclu = (retourExclu) => async (dispatch, getState) => {
    dispatch(postRetourExcluRequest(retourExclu));

    let params = {
        niveau: retourExclu.niveau,
        code: retourExclu.code
    };

    let niveau = getState().administration.retourExclus.niveaux.find(x => x.id === retourExclu.niveau);

    try {
        let response = await axios.post(`api/retourExclus/`, params);
        dispatch(postRetourExcluSuccess(response.data));
        dispatch(addNotification(`L'exclusion pour le niveau "${niveau.libelle}" et le code "${retourExclu.code}", a bien été ajoutée.`, NotificationImportance.success));
    } catch (error) {
        console.error('_postRetourExclu : ', error);
        dispatch(postRetourExcluFailure(error));
        dispatch(addNotification(`Impossible d'ajouter l'exclusion pour le niveau "${niveau.libelle}" et le code "${retourExclu.code}".`, NotificationImportance.error));
    }

};

/**
 * DELETE_RETOUR_EXCLU_
 * ActionCreator pour la suppression d'un retourExclu
 */
const deleteRetourExcluRequest = retourExcluId => ({ type: Actions.DELETE_RETOUR_EXCLU_REQUEST, retourExcluId });
const deleteRetourExcluSuccess = retourExcluId => ({ type: Actions.DELETE_RETOUR_EXCLU_SUCCESS, retourExcluId });
const deleteRetourExcluFailure = error => ({ type: Actions.DELETE_RETOUR_EXCLU_FAILURE, error });

export const deleteRetourExclu = (retourExcluId) => (dispatch, getState) => {
    if (getState().administration.retourExclus.isLoading || getState().administration.retourExclus.isPatching) {
        return;
    }
    return dispatch(_deleteRetourExclu(retourExcluId));
};

const _deleteRetourExclu = (retourExcluId) => async (dispatch) => {

    dispatch(deleteRetourExcluRequest(retourExcluId));

    try {
        let response = await axios.delete(`api/retourExclus/${retourExcluId}`);
        dispatch(deleteRetourExcluSuccess(response.data));
        dispatch(addNotification(`Le retourExclu ${retourExcluId} a bien été supprimé.`, NotificationImportance.success));
    } catch (error) {
        console.error('_deleteRetourExclu : ', error);
        dispatch(deleteRetourExcluFailure(error));
        dispatch(addNotification(`Impossible de supprimer le retourExclu ${retourExcluId}.`, NotificationImportance.error));
    }
};

/**
 * PATCH_REPRESENTANT_
 * ActionCreator pour la modification d'un représentant
 */
const patchRepresentantRequest = representant => ({ type: Actions.PATCH_REPRESENTANT_REQUEST, representant });
const patchRepresentantSuccess = representant => ({ type: Actions.PATCH_REPRESENTANT_SUCCESS, representant });
const patchRepresentantFailure = error => ({ type: Actions.PATCH_REPRESENTANT_FAILURE, error });

export const patchRepresentant = (representant) => (dispatch, getState) => {
    if (getState().administration.representants.isPatching) {
        return;
    }
    return dispatch(_patchRepresentant(representant));
};

const _patchRepresentant = (representant) => async (dispatch) => {
    dispatch(patchRepresentantRequest(representant));

    let params = {
        pctJokerFraisRetour: representant.pctJokerFraisRetour.replace('.', ',')
    };

    try {
        let response = await axios.patch(`api/representants/${representant.code}`, params);
        dispatch(patchRepresentantSuccess(response.data));
        dispatch(addNotification(`Le representant ${representant.code} - ${representant.nom} a bien été modifié.`, NotificationImportance.success));
    } catch (error) {
        console.error('_patchRepresentant error : ', error);
        dispatch(patchRepresentantFailure(error));
        dispatch(addNotification(`Impossible de modifier le representant ${representant.code} - ${representant.nom}.`, NotificationImportance.error));
    }
};